import type { ThemeState } from '@atlaskit/tokens/theme-config';
import { setGlobalTheme } from '@atlaskit/tokens/set-global-theme';

export const applyTheme = async (theme: Partial<ThemeState>): Promise<void> => {
	await setGlobalTheme(theme);
};
